/* PDP gallery — scroll indicator.

   Dots rather than a progress bar: a gallery has a small, countable number
   of images, and four dots communicates "four photos, you are on the first"
   in a way a bar cannot. Above six images counting stops being useful, so it
   falls back to a proportional bar.

   Built in JS rather than markup so a script failure leaves a working
   gallery with no indicator, rather than dead dots that never light up.
*/
(function () {
  'use strict';

  function build(gallery) {
    if (gallery.dataset.dotsBound) return;

    var slides = gallery.querySelectorAll('.pdp-img');
    if (slides.length < 2) return;          /* nothing to signify */
    gallery.dataset.dotsBound = '1';

    var many = slides.length > 6;
    var nav = document.createElement('div');
    nav.className = 'pdp-dots' + (many ? ' pdp-dots--bar' : '');
    nav.setAttribute('aria-hidden', 'true');

    if (many) {
      nav.innerHTML = '<span class="pdp-dots__thumb"></span>';
    } else {
      for (var i = 0; i < slides.length; i++) {
        nav.appendChild(document.createElement('span'));
      }
    }
    gallery.insertAdjacentElement('afterend', nav);

    var dots = nav.children;
    var raf = null;

    function paint() {
      raf = null;
      var max = gallery.scrollWidth - gallery.clientWidth;

      /* Nothing to scroll — hide rather than show an indicator that implies
         movement the gallery does not have. */
      if (max <= 1) { nav.style.display = 'none'; return; }
      nav.style.display = '';

      var progress = gallery.scrollLeft / max;   /* 0..1 */

      if (many) {
        var thumb = dots[0];
        var ratio = gallery.clientWidth / gallery.scrollWidth;
        var pct = Math.max(ratio * 100, 18);
        thumb.style.width = pct + '%';
        thumb.style.transform =
          'translateX(' + (progress * (100 / pct) * (100 - pct)) + '%)';
        return;
      }

      var active = Math.round(progress * (dots.length - 1));
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('is-on', i === active);
      }
    }

    function schedule() { if (raf === null) raf = requestAnimationFrame(paint); }

    gallery.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });

    /* Images load late and change scrollWidth. */
    if ('ResizeObserver' in window) new ResizeObserver(schedule).observe(gallery);

    paint();
  }

  function init() {
    document.querySelectorAll('.pdp-imgs').forEach(build);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
